import { TableViewStore, BaseListViewStore } from 'core/stores';
import applicationContext from 'core/utils/applicationContext';
import { DiagnosisCodeService } from 'application/import/services';
import { resolveColumns } from 'application/facility/util/resolveColumns';
import { GridBooleanCell } from 'core/components';
import { action } from 'mobx';

@applicationContext
class DiagnosisCodeListViewStore extends BaseListViewStore {
    constructor(rootStore) {
        const diagnosisCodeService = new DiagnosisCodeService(rootStore.application.baasic.apiClient);

        super(rootStore, {
            name: 'diagnosis-code',
            autoInit: true,
            authorization: {
                create: 'portalSection.create',
                delete: 'portalSection.delete',
            },
            routes: {
                create: () => this.rootStore.routerStore.goTo(
                    'master.app.main.diagnosis-code.create'
                ),
                edit: item => {
                    this.setChildNavigationTitle(i => 
                        i.id === item.id, 
                        () => item.name
                    );
                    return this.rootStore.routerStore.goTo(
                        'master.app.main.diagnosis-code.edit',
                        { id: item.id }
                    )
                },
            },
            actions: () => {
                return {
                    find: async (params) => {
                        const response = await diagnosisCodeService.find({...params, embed:"DiagnosisCodeCategories,DiagnosisCodeJustificationTypes"});
                        response.data.item = response.data.item.map(diagnosisCode => {
							let diagnosisCodeCategories = diagnosisCode.diagnosisCodeCategories &&
                            diagnosisCode.diagnosisCodeCategories.map(i=>i.itemCategory.name).join(", ");

                            let diagnosisCodeJustificationTypes = diagnosisCode.diagnosisCodeJustificationTypes &&
                            diagnosisCode.diagnosisCodeJustificationTypes.map(i=>i.justificationType && i.justificationType.name).join(", ");

							return {
								...diagnosisCode, 
								diagnosisCodeCategories: diagnosisCodeCategories,
                                diagnosisCodeJustificationTypes: diagnosisCodeJustificationTypes
							}
                        });
                        return response.data;
                    },
                    delete: async (item) => {
                        await diagnosisCodeService.delete(item);
                    }
                }
            }
        });

        this.setTableStore(new TableViewStore(this.queryUtility, {
            columns: resolveColumns([
                {
                    key: 'code',
                    title: 'DIAGNOSIS_CODE.LIST.COLUMNS.CODE',
                    onClick: item => this.routes.edit(item),
                },
                {
                    key: 'name',
                    title: 'DIAGNOSIS_CODE.LIST.COLUMNS.NAME',
                    onClick: item => this.routes.edit(item)
                },
                {
                    key: 'diagnosisCodeCategories',
                    title: 'DIAGNOSIS_CODE.LIST.COLUMNS.CATEGORIES',
                    onClick: item => this.routes.edit(item),
                    sortable:false
                },
                {
                    key: 'diagnosisCodeJustificationTypes',
                    title: 'DIAGNOSIS_CODE.LIST.COLUMNS.JUSTIFICATION_TYPES',
                    onClick: item => this.routes.edit(item),
                    sortable:false
                },
                {
                    key: 'isBillable',
                    title: 'DIAGNOSIS_CODE.LIST.COLUMNS.IS_BILLABLE',
                    onClick: item => this.routes.edit(item),
                    cell: GridBooleanCell,
                    displayFaultyValue: true,
                    headerClassName: 'center'
                }
            ]),
            actions: {
                onEdit: async (item) => this.routes.edit(item),
                onDelete: async (item) => this.deleteResource(item)
            }
        }));
        this.diagnosisCodeService = diagnosisCodeService;
    }

    @action.bound
    async deleteResource(item) {
		const { modalStore, notificationStore } = this.rootStore;

		modalStore.showConfirm(
			'DIAGNOSIS_CODE.DELETE.MESSAGE',
			async () => {
				try {
					await this.actions.delete(item);
					notificationStore.success('DIAGNOSIS_CODE.DELETE.SUCCESS');
					await this.queryUtility.fetch();
				} catch (err) {
					notificationStore.error('DIAGNOSIS_CODE.DELETE.ERROR', err);
				}
			}
		);
	}
}

export default DiagnosisCodeListViewStore;
